import React from 'react';
import { useHistory } from 'react-router-dom';

export const ScrollTopOnPathChanged: React.FC = ({ children }) => {
  const history = useHistory();
  const [path, setPath] = React.useState<string>(history.location.pathname);
  React.useEffect(() => {
    if (path !== history.location.pathname) {
      window.scrollTo(0, 0);
    }
    setPath(history.location.pathname);
  }, [path, history.location.pathname]);
  return <>{children}</>;
};
